<template>
  <div class="flex items-center space-x-2">
    <span
        class="cursor-pointer"
    >
      {{ (listSize === 1) ? this.filteredList[0] : `${listSize} items` }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'ListSizeRenderer',
  props: ['params'],
  computed: {
    filteredList() {
      const list = this.params.value;

      if( !list ) return [];
      if( !Array.isArray(list) ) return [];

      return list.filter( item => item.length !== 0 ).sort();
    },
    listSize() {
      return this.filteredList.length;
    },
  },
};
</script>

<style scoped>
</style>
